import { render, staticRenderFns } from "./RiskControlFlow.vue?vue&type=template&id=98f46026&scoped=true"
import script from "./RiskControlFlow.vue?vue&type=script&lang=js"
export * from "./RiskControlFlow.vue?vue&type=script&lang=js"
import style0 from "./RiskControlFlow.vue?vue&type=style&index=0&id=98f46026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f46026",
  null
  
)

export default component.exports